export const KEEPERS = [
  {
    "id": "gojo",
    "name": "Годжо",
    "series": "Магическая битва",
    "title": "Бесконечность",
    "color": "#aa8cff",
    "phrases": [
      "Между мячом и воротами — бесконечность.",
      "Думаешь, сможешь пробить меня?",
      "Мяч до ворот не долетит.",
      "Слишком медленно.",
      "Я уже знаю, куда ты ударишь.",
      "Попробуй обойти мою Бесконечность.",
      "Эти ворота под моей защитой.",
      "Даже не напрягся.",
      "Целься лучше.",
      "Осталось мало попыток.",
      "Шесть глаз видят твой удар.",
      "Ты правда выбрал этот угол?",
      "Почти попал. Почти.",
      "Давай, удиви сильнейшего.",
      "Я здесь сильнейший.",
      "Тебе осталось всего несколько ударов.",
      "Этот удар я тоже заберу.",
      "Ворота для тебя закрыты.",
      "Последние попытки — не промахнись.",
      "Покажи мне свой максимум."
    ],
    "quotes": {
      "ready": [
        0,
        1,
        4,
        5,
        6,
        8,
        13,
        14,
        19
      ],
      "save": [
        3,
        7,
        10,
        11,
        12,
        16,
        17
      ],
      "goal": [
        13,
        19,
        8
      ]
    }
  },
  {
    "id": "saitama",
    "name": "Сайтама",
    "series": "Ванпанчмен",
    "title": "Серьёзная защита",
    "color": "#f4c644",
    "phrases": [
      "А можно посильнее?",
      "Это уже был удар?",
      "Я даже не двигался.",
      "Слишком просто.",
      "Давай ещё раз.",
      "Может, теперь серьёзно?",
      "Я просто поймаю.",
      "Опять прямо в руки.",
      "Мне даже скучно стало.",
      "Всего 10 ударов? Ладно.",
      "Уже заканчиваются попытки?",
      "Попробуй хотя бы удивить меня.",
      "Я ждал чего-то мощнее.",
      "Это твой сильнейший удар?",
      "Даже перчатки не нужны.",
      "Мяч какой-то медленный.",
      "Ещё один?",
      "Не переживай, шанс ещё есть.",
      "Остался последний? Давай.",
      "Серьёзная защита."
    ],
    "quotes": {
      "ready": [
        0,
        1,
        4,
        5,
        8,
        11,
        12,
        13,
        16,
        19
      ],
      "save": [
        2,
        3,
        6,
        7,
        14,
        15
      ],
      "goal": [
        0,
        5,
        11,
        13,
        17
      ]
    }
  },
  {
    "id": "buddha",
    "name": "Будда",
    "series": "Повесть о конце света",
    "title": "Взгляд в будущее",
    "color": "#5ee3c0",
    "phrases": [
      "Я уже видел этот удар.",
      "Будущее нельзя обмануть.",
      "Я знаю, куда полетит мяч.",
      "Твой выбор уже сделан.",
      "Спокойствие. Я всё вижу.",
      "Попробуй изменить будущее.",
      "Этот угол я уже видел.",
      "Не торопись с ударом.",
      "Судьба мяча — в моих руках.",
      "Десять ударов. Выбирай мудро.",
      "Я вижу твоё намерение.",
      "Хитрый удар. Но предсказуемый.",
      "Твоя следующая попытка будет лучше?",
      "Не позволяй эмоциям управлять ударом.",
      "Я видел и этот вариант.",
      "Осталось совсем немного.",
      "Будущее становится интереснее.",
      "Сможешь сделать то, чего я не предвижу?",
      "Последний шанс изменить судьбу.",
      "Покажи невозможное."
    ],
    "quotes": {
      "ready": [
        1,
        3,
        4,
        5,
        7,
        10,
        13,
        17,
        19
      ],
      "save": [
        0,
        2,
        6,
        8,
        11,
        14
      ],
      "goal": [
        5,
        12,
        16,
        17,
        19
      ]
    }
  },
  {
    "id": "gagamaru",
    "name": "Гагамару",
    "series": "Блю Лок",
    "title": "Дикий инстинкт",
    "color": "#76c9fd",
    "phrases": [
      "Мои ворота — моя территория!",
      "Я достану этот мяч!",
      "Бей куда хочешь!",
      "Рефлексы меня не подведут.",
      "Я чувствую траекторию!",
      "Хороший удар!",
      "Но этого недостаточно!",
      "Попробуй в другой угол!",
      "Я ещё даже не разогрелся!",
      "У тебя всего 10 попыток!",
      "Давай сильнее!",
      "Я дотянусь!",
      "Этот мяч мой!",
      "Инстинкт не ошибается!",
      "Думаешь, туда не достану?",
      "Я закрою весь створ!",
      "Осталось несколько ударов!",
      "Сейчас будет сложнее!",
      "Последний удар? Я готов!",
      "Забить мне будет непросто!"
    ],
    "quotes": {
      "ready": [
        0,
        1,
        2,
        3,
        4,
        7,
        8,
        10,
        14,
        15,
        19
      ],
      "save": [
        1,
        6,
        11,
        12,
        13,
        15
      ],
      "goal": [
        5,
        7,
        10,
        14
      ]
    }
  },
  {
    "id": "killua",
    "name": "Киллуа",
    "series": "Хантер × Хантер",
    "title": "Скорость молнии",
    "color": "#88bfff",
    "phrases": [
      "Я быстрее твоего мяча.",
      "Слишком заметное движение.",
      "Уже понял, куда бьёшь.",
      "Рефлексы решают.",
      "Попробуй быстрее.",
      "Ты выдал направление глазами.",
      "Я был там раньше мяча.",
      "Неплохая попытка.",
      "Но слишком предсказуемо.",
      "Всего десять? Хватит.",
      "Теперь моя очередь ускориться.",
      "Попробуй обмануть меня.",
      "Ты слишком долго целишься.",
      "Этот угол закрыт.",
      "Почти заставил меня напрячься.",
      "Осталось мало попыток.",
      "Не повторяй предыдущую ошибку.",
      "Я уже привык к твоим ударам.",
      "Последний шанс. Не тормози.",
      "Скорость — это всё."
    ],
    "quotes": {
      "ready": [
        0,
        1,
        3,
        4,
        5,
        9,
        11,
        12,
        18,
        19
      ],
      "save": [
        2,
        6,
        7,
        8,
        13,
        17
      ],
      "goal": [
        7,
        11,
        14,
        18
      ]
    }
  },
  {
    "id": "ayanokoji",
    "name": "Аянокоджи",
    "series": "Класс превосходства",
    "title": "Холодный расчёт",
    "color": "#e6947f",
    "phrases": [
      "Направление удара очевидно.",
      "Я уже проанализировал тебя.",
      "Ты повторяешь один паттерн.",
      "Предсказуемо.",
      "Сила без расчёта бесполезна.",
      "Ты посмотрел в угол перед ударом.",
      "Я ожидал именно этого.",
      "Измени стратегию.",
      "Твои движения выдают намерение.",
      "Десяти ударов достаточно для анализа.",
      "Теперь я знаю твой стиль.",
      "Вероятность гола снижается.",
      "Ты снова совершил ту же ошибку.",
      "Попробуй действовать нелогично.",
      "Этот вариант я тоже учёл.",
      "У тебя остаётся мало попыток.",
      "Давление влияет на твои решения.",
      "Не показывай, куда собираешься бить.",
      "Последний удар наиболее показателен.",
      "Посмотрим, способен ли ты адаптироваться."
    ],
    "quotes": {
      "ready": [
        1,
        4,
        7,
        8,
        9,
        13,
        14,
        16,
        17,
        19
      ],
      "save": [
        0,
        2,
        3,
        5,
        6,
        10,
        12
      ],
      "goal": [
        7,
        13,
        18,
        19
      ]
    }
  },
  {
    "id": "goku",
    "name": "Гоку",
    "series": "Драконий жемчуг",
    "title": "Предел силы",
    "color": "#ffae55",
    "phrases": [
      "О, хороший удар!",
      "Давай ещё сильнее!",
      "Теперь становится интересно!",
      "Я готов!",
      "Попробуй пробить со всей силы!",
      "Ха! Поймал!",
      "Вот это уже лучше!",
      "Ты становишься сильнее!",
      "Не сдерживайся!",
      "Десять ударов? Отлично!",
      "Давай следующий!",
      "Почти получилось!",
      "Покажи свою настоящую силу!",
      "Я тоже ускорюсь!",
      "Отличная попытка!",
      "Осталось совсем немного!",
      "Не сдавайся!",
      "Этот удар должен быть сильнее!",
      "Последний? Выложись полностью!",
      "Давай узнаем твой предел!"
    ],
    "quotes": {
      "ready": [
        1,
        3,
        4,
        8,
        9,
        10,
        12,
        16,
        19
      ],
      "save": [
        5,
        11,
        13,
        17
      ],
      "goal": [
        0,
        2,
        6,
        7,
        14,
        16,
        19
      ]
    }
  },
  {
    "id": "jotaro",
    "name": "Джотаро",
    "series": "Невероятные приключения ДжоДжо",
    "title": "Стальная защита",
    "color": "#c3a568",
    "phrases": [
      "Яре яре дазе...",
      "Слишком очевидно.",
      "Бесполезно.",
      "Я видел твой удар.",
      "Попробуй ещё раз.",
      "Не трать моё время.",
      "Этот мяч не пройдёт.",
      "Ты слишком медленный.",
      "Предсказуемый удар.",
      "Всего десять попыток.",
      "И это всё?",
      "Следующий.",
      "Ты целишься слишком заметно.",
      "Ворота закрыты.",
      "Даже Star Platinum успел бы.",
      "Осталось несколько ударов.",
      "Становится скучно.",
      "Не промахнись снова.",
      "Последняя попытка.",
      "Яре яре... бей уже."
    ],
    "quotes": {
      "ready": [
        0,
        4,
        5,
        6,
        9,
        11,
        12,
        13,
        19
      ],
      "save": [
        1,
        2,
        3,
        7,
        8,
        10,
        14,
        16
      ],
      "goal": [
        0,
        4,
        10,
        11,
        19
      ]
    }
  },
  {
    "id": "bakugo",
    "name": "Бакуго",
    "series": "Моя геройская академия",
    "title": "Взрывной характер",
    "color": "#ff926b",
    "phrases": [
      "ДАВАЙ, БЕЙ!",
      "Это ты называешь ударом?!",
      "СИЛЬНЕЕ!",
      "Я заберу этот мяч!",
      "Не целься так очевидно!",
      "Слабовато!",
      "Ты мне не забьёшь!",
      "Попробуй ещё раз!",
      "Я закрою эти ворота!",
      "У тебя только 10 ударов!",
      "Хватит промахиваться!",
      "Бей нормально!",
      "Этот угол мой!",
      "Давай! Покажи максимум!",
      "Почти?! Мне плевать на почти!",
      "Попытки заканчиваются!",
      "Думаешь, я пропущу?!",
      "Не беси меня!",
      "ПОСЛЕДНИЙ УДАР! ДАВАЙ!",
      "ПРОБЕЙ МЕНЯ, ЕСЛИ СМОЖЕШЬ!"
    ],
    "quotes": {
      "ready": [
        0,
        2,
        3,
        4,
        7,
        8,
        11,
        13,
        17,
        19
      ],
      "save": [
        1,
        5,
        6,
        12,
        14,
        16
      ],
      "goal": [
        0,
        2,
        7,
        13,
        19
      ]
    }
  },
  {
    "id": "naruto",
    "name": "Наруто",
    "series": "Наруто",
    "title": "Воля огня",
    "color": "#ffc968",
    "phrases": [
      "Я не пропущу! Даттебайо!",
      "Давай, попробуй!",
      "Я не сдамся!",
      "Этот мяч мой!",
      "Хороший удар!",
      "Но следующий будет сложнее!",
      "Я защищу эти ворота!",
      "Попробуй другой угол!",
      "Я успею!",
      "У тебя всего десять попыток!",
      "Не недооценивай меня!",
      "Я становлюсь только сильнее!",
      "Почти получилось!",
      "Давай ещё раз!",
      "Я вижу твой удар!",
      "Осталось совсем немного!",
      "Не сдавайся раньше времени!",
      "Покажи всё, что умеешь!",
      "Последний удар — выложись полностью!",
      "Я стану лучшим вратарём! Даттебайо!"
    ],
    "quotes": {
      "ready": [
        0,
        1,
        2,
        6,
        7,
        8,
        10,
        13,
        17,
        19
      ],
      "save": [
        3,
        5,
        11,
        14
      ],
      "goal": [
        4,
        7,
        12,
        13,
        16,
        17
      ]
    }
  }
];

export function getKeeper(id) {
  return KEEPERS.find(keeper => keeper.id === id) || KEEPERS[0];
}

export function readKeeper(storage, key) {
  try { return getKeeper(storage.getItem(key)).id; } catch { return KEEPERS[0].id; }
}

export function keeperQuote(keeper, event = "ready", previous = "", random = Math.random, goals = 0) {
  const used = new Set(Object.values(keeper.quotes).flat());
  const unassigned = keeper.phrases.map((_, index) => index).filter(index => !used.has(index));
  const pool = [...(keeper.quotes[event] || keeper.quotes.ready),
    ...(event === "ready" ? unassigned : event === "goal" ? unassigned.filter(index => /последн|остал|заканч/i.test(keeper.phrases[index])) : [])];
  const contextual = pool.map(index => keeper.phrases[index]).filter(phrase => {
    if (/последн/i.test(phrase)) return goals === 9;
    if (/остал|заканч/i.test(phrase)) return goals >= 7;
    if (/10|десять|десяти/i.test(phrase)) return goals === 0;
    return true;
  });
  const candidates = contextual.filter(phrase => phrase !== previous);
  return candidates[Math.floor(random() * candidates.length)] || contextual[0] || keeper.phrases[0];
}
